// extracted by mini-css-extract-plugin
module.exports = {"notification":"_1adfA-V-Wq"};
    if(module.hot) {
      // 1597843253330
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  